import { createStore } from "zustand/vanilla";
import { compare } from "@pack-it-up/shared";
import { errorToMessage } from "../errorToMessage.js";
// Doc 10 §1–2: group the trip list relative to today. A trip with no start date
// is "dateless"; otherwise its end (or start) date decides upcoming vs past.
export const groupTrips = (trips, today) => {
    const upcoming = [];
    const dateless = [];
    const past = [];
    for (const t of trips) {
        if (t.startDate == null) {
            dateless.push(t);
            continue;
        }
        const anchor = t.endDate ?? t.startDate;
        if (compare(anchor, today) < 0)
            past.push(t);
        else
            upcoming.push(t);
    }
    upcoming.sort((a, b) => compare(a.startDate, b.startDate)); // soonest first
    past.sort((a, b) => compare(b.endDate ?? b.startDate, a.endDate ?? a.startDate)); // most recent first
    return { upcoming, dateless, past };
};
export const createHomeStore = (deps) => {
    const archived = deps.archived ?? false;
    // Stream subscriptions are owned by the store: dispose() unsubscribes them all, so a
    // superseded store stops writing into state nothing renders. `subs` is filled after
    // the store exists (the streams push into it).
    const subs = [];
    const store = createStore((set, get) => ({
        trips: [],
        templates: [],
        error: null,
        groups: () => groupTrips(get().trips, deps.today()),
        createTrip: async (input) => {
            const r = await deps.trips.createTrip(input);
            set({ error: r.ok ? null : errorToMessage(r.error) });
            return r;
        },
        createTemplate: async (input) => {
            const r = await deps.templates.createTemplate(input);
            set({ error: r.ok ? null : errorToMessage(r.error) });
            return r;
        },
        dispose() {
            for (const unsubscribe of subs.splice(0))
                unsubscribe();
        },
    }));
    subs.push(deps.trips.observeMyTrips(deps.userId, { archived }).subscribe((trips) => store.setState({ trips })), deps.templates.observeMyTemplates(deps.userId, { archived }).subscribe((templates) => store.setState({ templates })));
    return store;
};
//# sourceMappingURL=homeStore.js.map